import { FormikHelpers } from "formik";
import { useCreatePhoneLine } from "./api/createPhoneLine";
import CreatePhoneLineForm from "./CreatePhoneLineForm";


const CreatePhoneLine = ({handleCloseModal}: CreatePhoneLineProps)  => {
  const createPhoneLineMutation = useCreatePhoneLine({data: {}});

  const initialValues: ICreatePhoneLineForm = {
    unitID: "",
    applProtocolNumber: "",
    applDate: null,
    offApplDate: null,
    deliveryDate: null,
    providerID: "",
    lineTypeID: "",
    phoneNumber: "",
    //bulkPhoneNumbersAdd: "1",
    pendingStatusID: "",
    comments: "",
    usedByID: "",
    sapCode: "",
    lineType: 1,
    isEmporiki: false,
    isCiti: false,
    descline: ""
  };

  const handleSubmit = async (values: ICreatePhoneLineForm, { setSubmitting }: FormikHelpers<ICreatePhoneLineForm>): Promise<void> => {
    try {
      await createPhoneLineMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <CreatePhoneLineForm initialValues={initialValues}  onSubmit={handleSubmit} />
  )
}

interface CreatePhoneLineProps {
  handleCloseModal: () => void;
}

export default CreatePhoneLine;